import { useEffect, useState } from "react";
import { getNewUsersRetentionByTimezoneTable } from "../../services/multiTimezone";
import {LANGUAGE_MAP} from "@/pages/dashboard/_config/constant";
import {getLocale} from "umi";
import {formatAccumulation, formatFilterValues} from "@/pages/dashboard/utils/utils";
import { useOverLimitTrigger } from "@/pages/dashboard/components/OverLimitTip";
import { SortItem } from "../../components/HeatMapTable";
/**
 * 按照接口区分为不同model
 * hook名称规范：use+接口名称+Data
 * @param props 父页面所有props
 * @param props: formValue 筛选器值
 * @param props: dispatch dva  dispatch方法
 * @returns
 * 获取数据的逻辑：dva中有数据则取dva中的数据，否则自己通过接口请求
 */

const useNewUsersRetentionHeatTableModel = (props: any, formValue: any, filterLoading: boolean, accumulated: string[], tablePaging: {}, sort: SortItem[], timezoneType: string) => {
  const { gameCode } = props;
  const [componentData, setComponentData] = useState({
    aggregation: [],
    metrics_list: [],
    row_count: 0,
  });

  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);
  const { overLimitBarTriggerKey, handleResponse } = useOverLimitTrigger();

  // 分页、排序改变的时候
  useEffect(() => {
    if (!formValue || filterLoading) return;
    getRetentionDataFunc(formValue, accumulated, tablePaging, sort);
  }, [JSON.stringify(formValue), JSON.stringify(accumulated), filterLoading]);

  const getRetentionDataFunc = (formValue: any, accumulated: string[], tablePaging: {}, sort: SortItem[]) => {
    const { rangeTime, timeType, diff, ...filters } = formValue;
    const accumulation = formatAccumulation(accumulated);
    let desc = sort?.[0]?.order === 'desc' || (!sort[0]);
    const orderBy = sort.map((value) => {
      desc = value.order === 'desc';
      return value.code;
    });
    // markets筛选器不存在的时候不传markets，存在的时候传[]
    const params = {
      game_code: gameCode,
      filters: formatFilterValues(filters),
      start_time: rangeTime?.[0],
      end_time: rangeTime?.[1],
      accumulation,
      period: 'daily',
      desc,
      sorted_by: orderBy.length ? orderBy[0] : 'date',
      page: tablePaging?.pageIndex,
      page_size: tablePaging?.pageSize,
      timezone_type: timezoneType,
      retention_type: "new"
    };
    setLoading(true);
    getNewUsersRetentionByTimezoneTable(params, LANGUAGE_MAP[getLocale()]).then((result: any) => {
      setLoading(false);
      setError(false);
      setComponentData(result);
      handleResponse(result?.front_logical_flag);
      // dispatch({
      //     type: "engagementServiceData/getCountryComprisionTableFunc",
      //     payload: {
      //         result
      //     }
      // });
    }).catch(() => {
      setError(true);
      setLoading(false);
    });
  };
  return {
    componentData,
    loading,
    error,
    getData: getRetentionDataFunc,
    overLimitBarTriggerKey,
  };
};

export default useNewUsersRetentionHeatTableModel;
